// 此版本发布于2020-09-07
let version = '1.6.8';

export default {
	v: version,
	version: version,
	// 主题名称
	type: [
		'primary',
		'success',
		'info',
		'error',
		'warning'
	]
}


// WEBPACK FOOTER //
// ./libs/config/config.js